export default __webpack_public_path__ + "static/media/msp-verification.871f9e26.svg";